












import { defineComponent, PropType, watch } from '@nuxtjs/composition-api';
import { BaseHeading } from '@shared/ui';
import kebabCase from 'lodash.kebabcase';

import CMSRenderer from '~/components/CMS/CMSRenderer.vue';
export default defineComponent({
  name: 'AnchorLinkedBlock',
  components: { CMSRenderer, BaseHeading },
  props: {
    blockTitle: {
      type: String,
      required: true,
    },
    blockTitleId: {
      type: String,
      required: true,
    },
    blockContent: {
      type: Array as PropType<
        {
          componentName: string;
          props?: Record<string, unknown>;
        }[]
      >,
      required: true,
    },
    observer: {
      /*
       * for some reason casting Object to IntersectionObserver doesn't work
       * solution here tells vue to ignore run-time type check by setting type as null
       * null is cast to IntersectionObserver for TS safe use in setup()
       */
      type: null as unknown as PropType<IntersectionObserver>,
      required: true,
    },
    observerId: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const titleId = kebabCase(props.blockTitle);

    watch(
      () => props.observer,
      () => {
        const observerTarget = window.document.getElementById(props.observerId.toString());
        if (observerTarget && props.observer) {
          props.observer.observe(observerTarget);
        }
      },
    );
    return { titleId };
  },
});
